// Home.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaLaptopCode, FaCloud, FaBrain, FaPenNib } from 'react-icons/fa';

const Home = () => {
  return (
    <motion.div
      className="home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
    >
      {/* Persistent Background Image */}
      <div className="background"></div>

      {/* Introduction Section */}
      <motion.h1
        className="heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        Hi, I'm Bhagya Trivedi
      </motion.h1>
      <motion.p
        className="subheading"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
      >
        A passionate <span className="highlight">Software Engineer </span> 
        specializing in Cloud Computing, Generative AI, and UI/UX Design.
      </motion.p>

      {/* Skills Section */}
      <motion.div
        className="skills"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
      >
        {[
          { name: 'Software Engineering', icon: <FaLaptopCode size={40} /> },
          { name: 'Cloud Computing', icon: <FaCloud size={40} /> },
          { name: 'Generative AI', icon: <FaBrain size={40} /> },
          { name: 'UI/UX Design', icon: <FaPenNib size={40} /> },
        ].map((skill, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.05, boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)' }}
            className="skill-card"
          >
            <div className="skill-icon">
              {skill.icon}
            </div>
            <span className="skill-name">
              {skill.name}
            </span>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Home;
